module.exports = __webpack_public_path__ + "img/nav_btn_menu_s1.b6c77a13.png";